<template>
  <v-dialog v-model="inputVal" persistent max-width="600px">
    <template>
      <v-form ref="form" v-model="formValid">
        <v-card>
          <v-card-title>
            <b>ดาวน์โหลด รายเดือน</b>
          </v-card-title>
          <v-card-text>
            <v-menu
              v-model="menuMonthPicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="monthPicker"
                  label="เอกสารของ ปี-เดือน"
                  append-icon="mdi-keyboard_arrow_down"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="monthPicker"
                type="month"
                @input="menuMonthPicker = false"
              ></v-date-picker>
            </v-menu>
            <!-- filter downloaded Xml -->
            <v-radio-group
              v-model="filter.downloadedXml"
              row
              class="ma-0 pa-0"
              dense
            >
              <template v-slot:label>
                <div class="tw-w-20">ค่าดาวน์โหลด</div>
              </template>
              <v-radio value="All">
                <template v-slot:label>
                  <div>ทั้งหมด</div>
                </template>
              </v-radio>
              <v-radio :disabled="fileType !== 'xml'" value="Downloaded">
                <template v-slot:label>
                  <div>ดาวน์โหลดแล้ว</div>
                </template>
              </v-radio>
              <v-radio :disabled="fileType !== 'xml'" value="NotDownloaded">
                <template v-slot:label>
                  <div>ยังไม่ดาวน์โหลด</div>
                </template>
              </v-radio>
            </v-radio-group>
            <!-- fileType -->
            <v-radio-group v-model="fileType" row class="ma-0 pa-0" dense>
              <template v-slot:label>
                <div class="tw-w-20">ประเภทไฟล์</div>
              </template>
              <v-radio value="xml">
                <template v-slot:label>
                  <div>XML</div>
                </template>
              </v-radio>
              <v-radio value="pdf">
                <template v-slot:label>
                  <div>PDF</div>
                </template>
              </v-radio>
            </v-radio-group>
            <div>
              จำนวน
              <b v-if="!isGettingDocCount">{{
                docCount?.toLocaleString() || "0"
              }}</b>
              <b v-else>...</b>
              รายการ
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="cancel">
              <v-icon large>mdi-close-circle-outline</v-icon>
              <b>ยกเลิก</b>
            </v-btn>
            <v-btn
              text
              color="#6ec39b"
              type="button"
              class="btn-submit"
              @click="confirm"
            >
              <b>ยืนยัน</b>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </template>
  </v-dialog>
</template>

<script>
import firebase from "firebase/app";
import moment from "moment";
import "moment/locale/th";
moment.locale("th");

function getCurrentMonth() {
  return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .substr(0, 7);
}

export default {
  props: ["value", "companyID", "documentTypeKey"],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      docCount: 0,
      isGettingDocCount: true,
      formValid: false,
      menuMonthPicker: false,
      monthPicker: getCurrentMonth(),
      fileType: "xml",
      filter: {
        downloadedXml: "All",
      },
    };
  },

  methods: {
    confirm() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.$emit("confirm", {
        month: this.monthPicker,
        fileType: this.fileType,
        filter: this.filter,
      });
      this.inputVal = false;
      this.menuMonthPicker = false;
    },
    cancel() {
      this.inputVal = false;
      this.menuMonthPicker = false;
    },
    async getDocsCountByRange(date) {
      this.isGettingDocCount = true;
      const companyID = this.$props.companyID;
      const documentTypeNumber = this.$props.documentTypeKey;
      const downloadedFilter = this.filter.downloadedXml; // "All" | "Downloaded" | "NotDownloaded"

      // console.log("documentTypeNumber:: ",  this.$props.documentTypeKey)

      const q = firebase
        .firestore()
        .collection(`Companies/${companyID}/Summaries`)
        .doc(`${date}`);

      q.get()
        .then((snapshot) => {
          if (!snapshot.exists) {
            this.docCount = 0;
            return;
          }
          const data = snapshot.data();
          // console.log("data:: ", data)
          let docCount = 0;

          if (documentTypeNumber) {
            // Specific document type
            const baseKey = `countsDocsType${documentTypeNumber}`;
            const downloadedKey = `${baseKey}DownloadedXml`;
            const baseCount = data[baseKey] || 0;
            const downloadedCount = data[downloadedKey] || 0;

            switch (downloadedFilter) {
              case "All":
                docCount = baseCount;
                break;
              case "Downloaded":
                docCount = downloadedCount;
                break;
              case "NotDownloaded":
                docCount = baseCount - downloadedCount;
                break;
            }
          } else {
            // All document types combined
            const allBaseKey = `countsDocsAll`;
            const allDownloadedKey = `countsDocsAllDownloadedXml`;
            const allCount = data[allBaseKey] || 0;
            const allDownloadedCount = data[allDownloadedKey] || 0;

            switch (downloadedFilter) {
              case "All":
                docCount = allCount;
                break;
              case "Downloaded":
                docCount = allDownloadedCount;
                break;
              case "NotDownloaded":
                docCount = allCount - allDownloadedCount;
                break;
            }
          }

          this.docCount = docCount;
        })
        .catch((error) => {
          console.error("Error counting documents:", error);
          throw error;
        })
        .finally(() => {
          this.isGettingDocCount = false;
        });
    },
  },
  created() {
    this.getDocsCountByRange(getCurrentMonth());
  },
  watch: {
    monthPicker(newVal) {
      this.getDocsCountByRange(newVal);
    },
    documentTypeKey(newVal) {
      this.getDocsCountByRange(getCurrentMonth());
    },
    filter: {
      handler(newVal) {
        this.getDocsCountByRange(this.monthPicker);
      },
      deep: true,
    },
    fileType(newVal) {
      if(newVal !== "xml") this.filter.downloadedXml = "All";
    },
  },
};
</script>
